// extracted by mini-css-extract-plugin
module.exports = {"page":"NotFoundPage_page__b_V7l","error_block":"NotFoundPage_error_block__h_Fwl","text":"NotFoundPage_text__T0XKj"};